export default {
    "yellow": 0xfed429,
    "red": 0xEC4E20,
    "green": 0x33CA7F,
    "black": 0x2E382E,
    "blue": 0x2589BD,
    "white": 0xFFFFFF,
}
